import { useTranslation } from "react-i18next";

export interface useInternationalizedItemsProps {
    key: string;
}

export const useInternationalizedItems = <T>({
    key,
}: useInternationalizedItemsProps): T => {
    const { t } = useTranslation();
    const itemsRaw = t(key, { returnObjects: true });

    return Array.isArray(itemsRaw) ? (itemsRaw as T) : ([] as unknown as T);
};
